<template>
  <v-row class="assign-courier">
    <v-col
      :xs="12"
      :sm="6"
      :md="5"
      :lg="4"
    >
      <h6 class="text-h6">
        {{ $t('global.courier') }}
      </h6>

      <v-form
        ref="form"
        class="d-print-none"
        @submit.prevent.native="onSubmit"
      >
        <!-- for Picker + Driver model -->
        <div v-if="pickerAndDriverView">
          <v-select
            v-if="order.ui_flags.can_assign_picker"
            v-model="selectedPicker"
            :error-messages="errors.courier_picker_id"
            :label="$t('global.preparation')"
            :items="order.store.pickers"
            item-text="full_name"
            item-value="id"
            dense
            outlined
          />

          <div
            v-if="order.picker_name"
            class="mb-1"
          >
            <b>{{ $t('global.preparation') }}:</b> {{ order.picker_name }}
          </div>

          <v-select
            v-if="order.ui_flags.can_assign_driver"
            v-model="selectedDriver"
            :error-messages="errors.courier_id"
            :label="$t('global.delivery')"
            :items="order.store.drivers"
            item-text="full_name"
            item-value="id"
            dense
            outlined
          />

          <div
            v-if="order.driver_name"
            class="mb-1"
          >
            <b>{{ $t('global.delivery') }}:</b> {{ order.driver_name }}
          </div>
        </div>

        <!-- for Shopper model -->
        <div v-if="shopperView">
          <v-select
            v-if="order.ui_flags.can_assign_shopper"
            v-model="selectedShopper"
            :error-messages="errors.courier_id"
            :label="$t('global.preparation_and_delivery')"
            :items="order.store.shoppers"
            item-text="full_name"
            item-value="id"
            dense
            outlined
          />

          <div
            v-if="order.driver_name"
            class="mb-1"
          >
            <b>{{ $t('global.preparation_and_delivery') }}:</b> {{ order.driver_name }}
          </div>
        </div>

        <!-- show error message -->
        <div
          v-if="errorMessage"
          class="response-error error--text"
        >
          {{ errorMessage }}
        </div>

        <!-- assign button -->
        <v-btn
          v-if="canAssign"
          :loading="assignmentLoading"
          type="submit"
          color="accent"
          small
          class="float-right"
        >
          <v-icon left>
            mdi-account-multiple-plus
          </v-icon>
          {{ $t('global.assign') }}
        </v-btn>
      </v-form>

      <!-- only printing view section -->
      <div class="d-none d-print-block assigned-couriers-print">
        <div v-if="!order.ui_flags.shopper_only">
          <b>{{ $t('global.preparation') }}:</b> {{ order.picker_name }}<br>
          <b>{{ $t('global.delivery') }}:</b> {{ order.driver_name }}<br>
        </div>
        <div v-if="order.ui_flags.shopper_only">
          <b>{{ $t('global.preparation_and_delivery') }}:</b> {{ order.driver_name }}
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import OrderApi from '../Api/OrderApi'

export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      assignmentLoading: false,
      errors: {},
      errorMessage: '',
      selectedDriver: null,
      selectedPicker: null,
      selectedShopper: null,
    }
  },

  computed: {
    pickerAndDriverView () {
      return !this.order.ui_flags.shopper_only || this.order.ui_flags.click_and_collect_available
    },
    shopperView () {
      return this.order.ui_flags.shopper_only && !this.order.ui_flags.click_and_collect_available
    },
    canAssign () {
      return this.order.ui_flags.can_assign_picker || this.order.ui_flags.can_assign_driver || this.order.ui_flags.can_assign_shopper
    },
  },

  mounted () {
    this.selectedPicker = this.order.courier_picker_id
    this.selectedDriver = this.order.courier_id
    this.selectedShopper = this.order.courier_id
  },

  methods: {
    /**
     * On assignment form submit
     */
    onSubmit () {
      this.errors = {}
      this.errorMessage = ''
      // The shopper or the picker must be set
      if (this.order.ui_flags.can_assign_picker && !this.selectedPicker) {
        this.errors.courier_picker_id = this.$t('order.assignment_required')
      }
      if ((this.order.ui_flags.can_assign_shopper && !this.selectedShopper)
        || (this.order.ui_flags.can_assign_driver && !this.selectedDriver)) {
        this.errors.courier_id = this.$t('order.assignment_required')
      }
      if (Object.keys(this.errors).length === 0) {
          this.assignmentLoading = true
        let data = {}

        if (this.shopperView) {
          data = {
            courier_id: this.selectedShopper
          }
        } else {
          data = {
            courier_picker_id: this.selectedPicker,
            courier_id: this.selectedDriver
          }
        }

        OrderApi.assignCourier(this.order.id, data)
          .then(() => {
            this.$toast.success(this.$t('order.assignment_updated'))
          })
          .catch(() => {
            this.$toast.error(this.$t('order.assignment_error'))
          })
          .finally(() => {
            this.assignmentLoading = false
            // Refresh the order data
            this.$store.dispatch('order/fetchOrder', this.order.id)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.assign-courier {
  margin-bottom: 50px;
  min-width: 400px;
}

.response-error {
  font-size: 15px;
}
</style>
